'use strict';

module.exports = all;

var trim = require('trim');
var one = require('./one');

/* Transform the children of `parent`. */
function all(h, parent) {
  var nodes = parent.children || [];
  var length = nodes.length;
  var values = [];
  var index = -1;
  var result;
  var head;

  while (++index < length) {
    result = one(h, nodes[index], parent);

    if (result) {
      if (index && nodes[index - 1].type === 'break') {
        if (result.value) {
          result.value = trim.left(result.value);
        }

        head = result.children && result.children[0];

        if (head && head.value) {
          head.value = trim.left(head.value);
        }
      }

      values = values.concat(result);
    }
  }

  return values;
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-html/~/mdast-util-to-hast/lib/all.js
// module id = 3
// module chunks = 96961042003272 139266963665775